import styled, { css } from 'styled-components';

import { colors, fontFamily } from '../../ui/variables';

const main = {
  height: {
    iphone: 48,
  },
};

const big = {
  height: {
    iphone: 72,
  },
};

const defaultTheme = css`
  background-color: ${colors.softBlue};
  border: solid 1px ${colors.softBlue};
  color: ${colors.mostlyWhite};

  .icon {
    svg {
      fill: ${colors.mostlyWhite};
    }
  }
`;

const lightTheme = css`
  background-color: ${colors.veryPaleBlue};
  border: solid 1px ${colors.veryPaleBlue};
  color: ${colors.veryDarkGrayishBlue};

  .icon {
    svg {
      fill: ${colors.veryDarkGrayishBlue};
    }
  }
`;

const veryDarkTheme = css`
  background-color: ${colors.veryDarkGrayishBlue};
  border: solid 1px ${colors.veryDarkGrayishBlue};
  color: ${colors.mostlyWhite};

  .icon {
    svg {
      fill: ${colors.mostlyWhite};
    }
  }
`;

const lightDisabledTheme = css`
  background-color: transparent;
  border: solid 1px ${colors.grayishBlue};
  color: ${colors.grayishBlue};

  .icon {
    svg {
      fill: ${colors.grayishBlue};
    }
  }
`;

const disabledTheme = css`
  background-color: ${colors.grayishBlue};
  border: solid 1px ${colors.grayishBlue};
  color: ${colors.mostlyWhite};

  .icon {
    svg {
      fill: ${colors.mostlyWhite};
    }
  }
`;

const limeGreenTheme = css`
  background-color: ${colors.limeGreen};
  border: solid 1px ${colors.limeGreen};
  color: ${colors.mostlyWhite};

  .icon {
    svg {
      fill: ${colors.mostlyWhite};
    }
  }
`;

const lightDashed = css`
  background-color: ${colors.veryPaleBlue};
  border: dashed 1px ${colors.softBlue};
  color: ${colors.softBlue};

  .icon {
    svg {
      fill: ${colors.softBlue};
    }
  }
`;

const whiteDashed = css`
  background-color: ${colors.mostlyWhite};
  border: dashed 1px ${colors.softBlue};
  color: ${colors.softBlue};

  .icon {
    svg {
      fill: ${colors.softBlue};
    }
  }
`;

export const ButtonStyle = styled.div`
  width: 100%;

  .button-element {
    ${fontFamily.sourceSansPro.bold}
    align-items: center;
    border-radius: 8px;
    display: flex;
    font-size: 14px;
    height: ${main.height.iphone}px;
    line-height: 14px;
    overflow: hidden;
    padding: 8px 16px;
    width: 100%;

    &.icon-only,
    &.icon-text {
      .icon {
        max-width: 16px;

        svg {
          display: block;
          height: auto;
          max-width: 16px;
          width: 100%;
        }
      }
    }

    &.icon-text {
      padding: 8px 48px;
      position: relative;
      text-align: center;
      width: 100%;

      &.icon-right {
        .icon {
          left: initial;
          right: 16px;
        }
      }

      &.text-align-left {
        text-align: left;
      }

      &.text-align-center {
        text-align: center;
      }

      &.text-align-right {
        text-align: right;
      }

      .icon {
        left: 16px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    &.icon-only {
      width: ${main.height.iphone}px;
    }

    &.text-align-left {
      .text {
        text-align: left;
      }
    }

    &.text-align-center {
      .text {
        text-align: center;
      }
    }

    &.text-align-right {
      .text {
        text-align: right;
      }
    }

    &.with-transition {
      transition: background-color 300ms, border 300ms, color 300ms;

      .icon {
        svg {
          transition: fill 300ms;
        }
      }
    }

    &.default-theme {
      ${defaultTheme};
    }

    &.very-dark-theme {
      ${veryDarkTheme};
    }

    &.light-theme {
      ${lightTheme};
    }

    &.light-menu-theme {
      ${lightTheme};
      box-shadow: 0px 10px 20px rgba(83, 107, 221, 0.2);
    }

    &.light-disabled-theme {
      ${lightDisabledTheme};
    }

    &.disabled-theme {
      ${disabledTheme};
    }

    &.lime-green-theme {
      ${limeGreenTheme};
    }

    &.disabled-lime-green-theme {
      ${limeGreenTheme};
    }

    &.dashed-light-theme {
      ${lightDashed};
    }

    &.dashed-white-theme {
      ${whiteDashed};
    }

    &.default-active-theme {
      ${defaultTheme};
    }

    &.very-dark-active-theme {
      ${veryDarkTheme};
    }

    &.light-active-theme {
      ${lightTheme};
    }

    &.light-disabled-active-theme {
      ${lightDisabledTheme};
    }

    &.disabled-active-theme {
      ${disabledTheme};
    }

    &.big-size {
      height: ${big.height.iphone}px;
      padding-bottom: 24px;
      padding-top: 24px;
    }

    &.small-size {
      height: 45px;
      padding-bottom: 14px;
      padding-top: 14px;
    }

    .text {
      display: block;
      white-space: nowrap;
      width: 100%;
    }
  }

  .submit-error {
    ${fontFamily.InputFieldStyle};
    color: ${colors.softRed};
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 4px;
  }
`;
